module.exports = __webpack_public_path__ + "img/delete icon.0ee3c442.svg";